var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import CompulsoryExtraBaseValidationMixin from './CompulsoryExtraBaseValidationMixin';
import * as yup from 'yup';
var PashaExtraValidationMixin = /** @class */ (function (_super) {
    __extends(PashaExtraValidationMixin, _super);
    function PashaExtraValidationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PashaExtraValidationMixin.prototype, "step2ValidationSchema", {
        get: function () {
            var _a, _b, _c;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step2) || {};
            var isResident = (_c = (_b = this.stepsData) === null || _b === void 0 ? void 0 : _b.step2) === null || _c === void 0 ? void 0 : _c.isResident;
            var commonFields = {
                firstName: yup
                    .string()
                    .required(t.first_name_required || 'Ad tələb olunur'),
                lastName: yup
                    .string()
                    .required(t.last_name_required || 'Soyad tələb olunur'),
                birthDate: yup
                    .string()
                    .required(t.birth_date_required || 'Doğum tarixi tələb olunur')
                    .matches(/^\d{2}-\d{2}-\d{4}$/, t.birth_date_invalid || 'Doğum tarixi düzgün deyil (DD-MM-YYYY)')
                    .test('is-valid-date', t.birth_date_invalid || 'Doğum tarixi düzgün deyil', function (value) {
                    if (!value)
                        return true;
                    var parts = value.split('-');
                    if (parts.length !== 3)
                        return false;
                    var day = parseInt(parts[0], 10);
                    var month = parseInt(parts[1], 10);
                    var year = parseInt(parts[2], 10);
                    if (isNaN(day) || isNaN(month) || isNaN(year))
                        return false;
                    if (month < 1 || month > 12 || day < 1 || day > 31)
                        return false;
                    var d = new Date(year, month - 1, day);
                    var currentYear = new Date().getFullYear();
                    return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day && year <= currentYear && year >= currentYear - 100;
                }),
                phone: yup
                    .string()
                    .required(t.phone_required || 'Telefon nömrəsi tələb olunur')
                    .test('phone-format', t.phone_invalid || 'Telefon nömrəsi düzgün formatda deyil', function (value) {
                    if (!value)
                        return true;
                    var digits = value.replace(/\D/g, '');
                    if (digits.length !== 12) {
                        return this.createError({
                            message: t.phone_invalid || 'Telefon nömrəsi tam daxil edilməlidir'
                        });
                    }
                    var operatorCode = digits.substring(3, 5);
                    var allowedCodes = ['10', '50', '51', '55', '70', '77', '99'];
                    if (!allowedCodes.includes(operatorCode)) {
                        return this.createError({
                            message: t.phone_operator_invalid || 'Operator kodu düzgün deyil (10, 50, 51, 55, 70, 77, 99)'
                        });
                    }
                    return true;
                }),
            };
            if (isResident === false) {
                return yup.object().shape(__assign(__assign({}, commonFields), { passportNumber: yup
                        .string()
                        .required(t.passport_number_required || 'Pasport nömrəsi tələb olunur') }));
            }
            return yup.object().shape(__assign(__assign({}, commonFields), { passport: yup
                    .string()
                    .required(t.passport_required || 'Şəxsiyyət vəsiqəsi tələb olunur')
                    .test('passport-length', t.passport_invalid || 'Şəxsiyyət vəsiqəsi düzgün formatda deyil', function (value) {
                    var _a;
                    if (!value)
                        return true;
                    var docType = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.docType;
                    var expectedLength = docType === 'AZE' ? 8 : 7;
                    var digitsOnly = /^\d+$/.test(value);
                    if (!digitsOnly) {
                        return this.createError({
                            message: t.passport_invalid || 'Şəxsiyyət vəsiqəsi yalnız rəqəmlərdən ibarət olmalıdır'
                        });
                    }
                    if (value.length !== expectedLength) {
                        var message = docType === 'AZE'
                            ? (t.passport_invalid_aze || 'Şəxsiyyət vəsiqəsi 8 rəqəmdən ibarət olmalıdır')
                            : (t.passport_invalid_other || 'Sənəd nömrəsi 7 rəqəmdən ibarət olmalıdır');
                        return this.createError({ message: message });
                    }
                    return true;
                }), fin: yup
                    .string()
                    .required(t.fin_required || 'FIN kod tələb olunur')
                    .length(7, t.fin_invalid || 'FIN kod 7 simvoldan ibarət olmalıdır'), docType: yup
                    .string()
                    .required() }));
        },
        enumerable: false,
        configurable: true
    });
    PashaExtraValidationMixin = __decorate([
        Component
    ], PashaExtraValidationMixin);
    return PashaExtraValidationMixin;
}(CompulsoryExtraBaseValidationMixin));
export default PashaExtraValidationMixin;
